module.exports = __webpack_public_path__ + "media/images/lp/industries/issue_automotive-ba64448543e57dec5fc8da2536191499.svg";